// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar {
    width: 250px;
    height: 100vh;
    background-color: #FFFFFF;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 20px;
    border-right: 1px solid #DFE7EF;
    position: fixed; /* Фиксированное положение */
    top: 0;
    left: 0;
    z-index: 1000;
}

/* Стиль для логотипа */
.sidebar .logo img {
    width: 160px;
    height: 45px;
    margin-bottom: 20px;
}

/* Основной стиль для элементов меню */
.menu {
    width: 100%;
    padding: 0;
    margin: 0;
    list-style-type: none;
}

.menu-item {
    list-style: none;
    display: flex;
    align-items: center;
    padding: 10px;
    gap: 7px;
    width: 236px;
    height: 35px;
    margin-bottom: 10px;
    color: #4B5563;
    background-color: #FFFFFF;
    border-radius: 8px;
    cursor: pointer;
    font-weight: 500;
    font-size: 14px;
    transition: background-color 0.3s, color 0.3s;
}

.menu-item:hover,
.menu-item.selected {
    background-color: #FFEFEF;
    color: #FF0000;
}

.menu-link {
    display: flex;
    align-items: center;
    width: 100%;
    text-decoration: none;
    color: inherit; /* Ensures text color is inherited */
    padding: 10px;
}

.menu-link:hover {
    color: #FF0000; /* Hover color */
}

.menu-item:hover .icon,
.menu-item.selected .icon,
.menu-item:hover .arrow,
.menu-item.selected .arrow {
    color: #FF0000; /* Окрашивание иконки и стрелки при наведении и выборе */
}

.menu-item .icon {
    font-size: 16px;
    color: inherit; /* Наследует цвет от родительского элемента */
}

.menu-item .arrow {
    margin-left: auto;
    color: inherit; /* Наследует цвет от родительского элемента */
    font-size: 12px;
}

/* Кнопка выхода */
.logout {
    margin-top: auto;
    padding: 10px;
    color: #FF0000;
    font-weight: 500;
    font-size: 14px;
    text-decoration: none;
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 25px;
    width: 236px;
    height: 35px;
    border-radius: 8px;
    background-color: #FFFFFF;
    cursor: pointer;
    outline: none; /* Убирает черную обводку при фокусе */
    border: none; /* Убирает рамку, если есть */
}

.logout .arrow {
    margin-left: auto;
    font-size: 12px;
    color: #FF0000;
}
`, "",{"version":3,"sources":["webpack://./src/style/Sidebar.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;IACjB,+BAA+B;IAC/B,eAAe,EAAE,4BAA4B;IAC7C,MAAM;IACN,OAAO;IACP,aAAa;AACjB;;AAEA,uBAAuB;AACvB;IACI,YAAY;IACZ,YAAY;IACZ,mBAAmB;AACvB;;AAEA,sCAAsC;AACtC;IACI,WAAW;IACX,UAAU;IACV,SAAS;IACT,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,QAAQ;IACR,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,6CAA6C;AACjD;;AAEA;;IAEI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,qBAAqB;IACrB,cAAc,EAAE,oCAAoC;IACpD,aAAa;AACjB;;AAEA;IACI,cAAc,EAAE,gBAAgB;AACpC;;AAEA;;;;IAII,cAAc,EAAE,wDAAwD;AAC5E;;AAEA;IACI,eAAe;IACf,cAAc,EAAE,6CAA6C;AACjE;;AAEA;IACI,iBAAiB;IACjB,cAAc,EAAE,6CAA6C;IAC7D,eAAe;AACnB;;AAEA,kBAAkB;AAClB;IACI,gBAAgB;IAChB,aAAa;IACb,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;IACf,aAAa,EAAE,sCAAsC;IACrD,YAAY,EAAE,6BAA6B;AAC/C;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,cAAc;AAClB","sourcesContent":[".sidebar {\n    width: 250px;\n    height: 100vh;\n    background-color: #FFFFFF;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding-top: 20px;\n    border-right: 1px solid #DFE7EF;\n    position: fixed; /* Фиксированное положение */\n    top: 0;\n    left: 0;\n    z-index: 1000;\n}\n\n/* Стиль для логотипа */\n.sidebar .logo img {\n    width: 160px;\n    height: 45px;\n    margin-bottom: 20px;\n}\n\n/* Основной стиль для элементов меню */\n.menu {\n    width: 100%;\n    padding: 0;\n    margin: 0;\n    list-style-type: none;\n}\n\n.menu-item {\n    list-style: none;\n    display: flex;\n    align-items: center;\n    padding: 10px;\n    gap: 7px;\n    width: 236px;\n    height: 35px;\n    margin-bottom: 10px;\n    color: #4B5563;\n    background-color: #FFFFFF;\n    border-radius: 8px;\n    cursor: pointer;\n    font-weight: 500;\n    font-size: 14px;\n    transition: background-color 0.3s, color 0.3s;\n}\n\n.menu-item:hover,\n.menu-item.selected {\n    background-color: #FFEFEF;\n    color: #FF0000;\n}\n\n.menu-link {\n    display: flex;\n    align-items: center;\n    width: 100%;\n    text-decoration: none;\n    color: inherit; /* Ensures text color is inherited */\n    padding: 10px;\n}\n\n.menu-link:hover {\n    color: #FF0000; /* Hover color */\n}\n\n.menu-item:hover .icon,\n.menu-item.selected .icon,\n.menu-item:hover .arrow,\n.menu-item.selected .arrow {\n    color: #FF0000; /* Окрашивание иконки и стрелки при наведении и выборе */\n}\n\n.menu-item .icon {\n    font-size: 16px;\n    color: inherit; /* Наследует цвет от родительского элемента */\n}\n\n.menu-item .arrow {\n    margin-left: auto;\n    color: inherit; /* Наследует цвет от родительского элемента */\n    font-size: 12px;\n}\n\n/* Кнопка выхода */\n.logout {\n    margin-top: auto;\n    padding: 10px;\n    color: #FF0000;\n    font-weight: 500;\n    font-size: 14px;\n    text-decoration: none;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    margin-bottom: 25px;\n    width: 236px;\n    height: 35px;\n    border-radius: 8px;\n    background-color: #FFFFFF;\n    cursor: pointer;\n    outline: none; /* Убирает черную обводку при фокусе */\n    border: none; /* Убирает рамку, если есть */\n}\n\n.logout .arrow {\n    margin-left: auto;\n    font-size: 12px;\n    color: #FF0000;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
